/* COVER11: native product options and an optional, reference-only vehicle picker. */
(() => {
  'use strict';
  const configNode = document.getElementById('Cover11ShoppingConfig');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const messages = config.messages || {};
  const t = key => messages[key] || key;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const storageKey = 'cover11.vehicle.v1';
  let catalogPromise, catalog = [], selected = null, opener = null;
  const readSaved = () => { try { const value = JSON.parse(localStorage.getItem(storageKey)); return typeof value?.id === 'string' ? value : null; } catch (_) { return null; } };
  const save = () => { try { if (selected) localStorage.setItem(storageKey, JSON.stringify({id: selected.id, year: selected.year || null})); else localStorage.removeItem(storageKey); } catch (_) { /* Private mode keeps the choice for this page. */ } };
  function embeddedVehicles() {
    const rows = [];
    document.querySelectorAll('[data-shop-fitments]').forEach(node => {
      try { for (const fit of JSON.parse(node.textContent)) {
        const car = fit.vehicle_details;
        if (car && car.id === fit.vehicle && typeof car.make === 'string' && car.make && typeof car.model === 'string' && car.model && Number.isInteger(car.from) && Number.isInteger(car.to) && car.from <= car.to) rows.push(car);
      } } catch (_) {}
    });
    return rows;
  }
  function loadCatalog() {
    if (!catalogPromise) {
      const embedded = embeddedVehicles();
      const validRow=row=>row&&typeof row.id==='string'&&row.id.length>0&&typeof row.make==='string'&&row.make.length>0&&typeof row.model==='string'&&row.model.length>0&&(Array.isArray(row.years)?row.years.every(year=>Number.isInteger(year)&&year>=1978&&year<=new Date().getFullYear()+1)&&(row.years.length?row.from===Math.min(...row.years)&&row.to===Math.max(...row.years):row.from===null&&row.to===null):Number.isInteger(row.from)&&Number.isInteger(row.to)&&row.from>=1978&&row.from<=row.to);
      const fetchCatalog=url=>fetch(url,{credentials:'omit',signal:AbortSignal.timeout(15000)}).then(response=>{if(!response.ok)throw new Error('catalog');return response.json();}).then(data=>{if(!Array.isArray(data)||!data.length||data.length>30000||data.some(row=>!validRow(row)))throw new Error('catalog');return data;});
      catalogPromise = fetchCatalog(config.catalogUrl).catch(()=>Array.isArray(config.fallbackCatalogUrls)&&config.fallbackCatalogUrls.length?Promise.all(config.fallbackCatalogUrls.map(fetchCatalog)).then(chunks=>chunks.flat()):fetchCatalog(config.fallbackCatalogUrl));
      catalogPromise = catalogPromise.catch(error => { if (embedded.length) return []; throw error; }).then(data => {
        if (!Array.isArray(data)) { if (embedded.length) data = []; else throw new Error('catalog'); }
        const rows = [...data, ...embedded].filter(validRow);
        catalog = [...new Map(rows.map(row => [row.id, row])).values()];
        if (!catalog.length) throw new Error('catalog');
        return catalog;
      }).catch(error => { catalogPromise = null; throw error; });
    }
    return catalogPromise;
  }
  const fullName = car => `${normalize(car.make)===normalize(car.model)?car.model:car.make+' '+car.model}${car.year ? ' · '+car.year : ''}`;
  const hasYear = (car, year) => Number.isInteger(Number(year)) && (Array.isArray(car.years) ? car.years.includes(Number(year)) : Number(year) >= car.from && Number(year) <= car.to);
  const sameIdentity = (car, fit) => Boolean(car && fit && (car.id === fit.vehicle || (Number(car.nhtsaMakeId)>0 && Number(car.nhtsaModelId)>0 && Number(car.nhtsaMakeId) === Number(fit.vehicle_details?.nhtsaMakeId) && Number(car.nhtsaModelId) === Number(fit.vehicle_details?.nhtsaModelId))));
  function notifyChoice() {
    document.querySelectorAll('[data-shop-vehicle-label]').forEach(label => {
      label.textContent = selected ? fullName(selected) : t('car');
      label.closest('a')?.setAttribute('aria-label', selected ? `${t('change_car')}: ${fullName(selected)}` : t('choose_car'));
    });
    window.dispatchEvent(new CustomEvent('cover11:vehicle-change', {detail: selected}));
  }
  function select(car, year) { if(car && year && !hasYear(car,year)) throw new Error('Unknown model year'); selected = car ? {...car,year:year?Number(year):null} : null; save(); notifyChoice(); }
  function syncLock() { document.documentElement.classList.toggle('c11-shop-modal-open', Boolean(document.querySelector('dialog.c11-shop-dialog[open]'))); }
  function showModal(target, origin) {
    if (!target || !target.showModal) return false;
    opener = origin || document.activeElement;
    target._cover11ReturnTo = opener;
    document.querySelector('[data-c11-menu-close]')?.click();
    const cartClose = document.querySelector('[data-c11-cart-drawer]:not([hidden]) [data-c11-cart-close]'); cartClose?.click();
    document.querySelectorAll('[data-c11-panel]:not([hidden])').forEach(panel => { panel.hidden = true; });
    document.querySelector('[data-c11-drawer]')?.classList.remove('is-open');
    const oldCart = document.querySelector('[data-c11-cart-drawer]:not([hidden])'); if (oldCart) oldCart.hidden = true;
    document.querySelectorAll('header [aria-expanded="true"]').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
    if (!target.open) target.showModal();
    syncLock();
    return true;
  }
  function closeModal(target) { if (target?.open) { target.close(); syncLock(); } }
  function initDialog(target) {
    if (!target || target.dataset.shopDialogReady) return;
    target.dataset.shopDialogReady = 'true';
    target.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); closeModal(target); }
      if (event.key === 'Tab') {
        const nodes = [...target.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex="0"]')].filter(node => node.getClientRects().length && !node.closest('[hidden],[inert]'));
        const first = nodes[0], last = nodes[nodes.length-1];
        if (nodes.length && event.shiftKey && (document.activeElement === first || !target.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (nodes.length && !event.shiftKey && (document.activeElement === last || !target.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
      }
    }, true);
    target.querySelectorAll('[data-shop-dialog-close]').forEach(button => button.addEventListener('click', () => closeModal(target)));
    target.addEventListener('click', event => { if (event.target === target) { const rect = target.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeModal(target); } });
    target.addEventListener('close', () => {
      syncLock();
      const origin = target._cover11ReturnTo;
      if (origin?.isConnected) {
        origin.setAttribute('aria-expanded', 'false');
        const focused = document.activeElement;
        if (focused === document.body || focused === document.documentElement || target.contains(focused)) {
          const returnTarget = origin.getClientRects().length && getComputedStyle(origin).visibility !== 'hidden' ? origin : document.querySelector('[data-c11-menu-open]');
          returnTarget?.focus({preventScroll:true});
        }
      }
    });
  }
  const matches = (car, query) => normalize(query).split(' ').filter(Boolean).every(token => {
    if (/^\d{4}$/.test(token)) return hasYear(car,Number(token));
    return normalize(`${car.make} ${car.model}`).replace(/ /g, '').includes(token);
  });
  function openVehicle(origin) {
    window.dispatchEvent(new CustomEvent('cover11:vehicle-picker-open', {detail:{origin}}));
    return true;
  }
  const selectVehicle = async (id, year) => { const rows = await loadCatalog(); const car = rows.find(row => row.id === id || row.legacyIds?.includes(id)); if (!car) throw new Error('Unknown reference'); select(car,year); return selected; };
  window.COVER11_SHOP = {vehicleName: fullName, openVehicle, getVehicle: () => selected, clearVehicle: () => select(null), listVehicles: loadCatalog, selectVehicle, hasYear, matchesFitment: sameIdentity};
  const requested=new URLSearchParams(location.search),saved=readSaved();
  const requestedId=requested.get('vehicle'),requestedYear=requested.get('year');
  const initial=requestedId?{id:requestedId,year:requestedYear}:saved;
  if(initial)selectVehicle(initial.id,initial.year).catch(()=>{if(!requestedId)select(null);});
  window.addEventListener('storage', event => {
    if (event.key !== storageKey) return;
    const saved = readSaved();
    if (!saved) { selected = null; notifyChoice(); return; }
    loadCatalog().then(rows => { const car=rows.find(row=>row.id===saved.id); selected=car?{...car,year:hasYear(car,saved.year)?Number(saved.year):null}:null;notifyChoice(); }).catch(() => {});
  });
  function initDirectory(root = document) {
    const input = root.querySelector('[data-shop-directory-query]');
    if (!input || input.dataset.shopReady) return;
    input.dataset.shopReady = 'true';
    root.querySelector('[data-shop-directory-controls]').hidden = false;
    const rows = [...root.querySelectorAll('[data-shop-directory-car]')];
    input.addEventListener('input', () => rows.forEach(row => {
      const searchText = row.dataset.shopDirectorySearch || row.textContent;
      const years = searchText.match(/(\d{4})[–-](\d{4})/);
      const car = {make: searchText, model: '', from: Number(years?.[1]), to: Number(years?.[2])};
      row.hidden = !matches(car, input.value);
    }));
    const requestedModel = new URLSearchParams(window.location.search).get('model');
    if (requestedModel) {
      input.value = requestedModel.slice(0, 120);
      input.dispatchEvent(new Event('input'));
    }
    rows.forEach(row => row.addEventListener('click', async event => {
      event.preventDefault();
      try { const cars = await loadCatalog(); const car = cars.find(item => item.id === row.dataset.shopDirectoryCar); if (car) select(car); window.location.assign(row.href); }
      catch (_) { window.location.assign(row.href); }
    }));
  }
  function initProduct(root) {
    if (root.dataset.shopReady) return;
    root.dataset.shopReady = 'true';
    const form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    let variants, fitments;
    try { variants = JSON.parse(root.querySelector('[data-shop-variants]').textContent); fitments = JSON.parse(root.querySelector('[data-shop-fitments]').textContent); }
    catch (_) { return; }
    const button = root.querySelector('[data-shop-add]');
    const errorNode = root.querySelector('[data-shop-product-error]');
    const addedNode = root.querySelector('[data-shop-product-added]');
    const quantity = form.elements.quantity;
    const mode = root.dataset.mode;
    const yearSelect = root.querySelector('[data-shop-fit-year]');
    const configSelect = root.querySelector('[data-shop-fit-configuration]');
    let busy = false, fitRows = [], fitCar = null;
    const variant = () => variants.find(item => String(item.id) === String(new FormData(form).get('id')));
    const setImage = (url, alt) => {
      const main = root.querySelector('.c11-shop-gallery__main');
      if (!main || !url) return;
      main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = url;
      if (alt) main.alt = alt;
      root.querySelectorAll('[data-shop-thumbnail]').forEach(link => { if (link.href === main.src) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current'); });
    };
    root.querySelectorAll('[data-shop-thumbnail]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); setImage(link.href, link.dataset.imageAlt); }));
    function fillOptions(selectElement, values, previous) {
      selectElement.replaceChildren(new Option(t('select_option'), ''));
      values.forEach(value => selectElement.add(new Option(String(value), String(value))));
      if (values.map(String).includes(previous)) selectElement.value = previous;
    }
    function rebuildFit() {
      if (mode !== 'custom_fit') return;
      const car = selected;
      const sameCar = fitCar === car?.id;
      const oldYear = sameCar ? yearSelect.value : '';
      const oldConfig = sameCar ? configSelect.value : '';
      fitCar = car?.id || null;
      fitRows = fitments.filter(row => car && sameIdentity(car,row) && (!car.year || car.year>=Number(row.from)&&car.year<=Number(row.to)) && Number.isInteger(Number(row.from)) && Number.isInteger(Number(row.to)) && Number(row.to) >= Number(row.from) && row.configuration && Array.isArray(row.variants));
      root.querySelector('[data-shop-fit-fields]').hidden = !fitRows.length;
      const years = new Set();
      fitRows.forEach(row => { for (let year = Math.max(Number(row.from), car.from); year <= Math.min(Number(row.to), car.to); year++) years.add(year); });
      fillOptions(yearSelect, [...years].filter(year=>hasYear(car,year)).sort((a,b) => b-a), String(car?.year||oldYear));
      fillOptions(configSelect, [...new Set(fitRows.map(row => row.configuration))], oldConfig);
      const link = root.querySelector('[data-shop-product-vehicle]');
      link.textContent = car ? `${fullName(car)} · ${t('change_car')}` : t('choose_car');
      const request = root.querySelector('[data-p3-request]');
      if(request){
        if(!request.dataset.defaultLabel){request.dataset.defaultLabel=request.textContent;request.dataset.defaultHref=request.getAttribute('href');}
        request.hidden=Boolean(car&&fitRows.length);
        if(car&&!fitRows.length){const url=new URL(config.directoryUrl,location.origin);url.pathname=url.pathname.replace(/pages\/all-vehicles$/,'pages/contact');url.search='';url.searchParams.set('topic','fit');url.searchParams.set('vehicle',fullName(car));url.searchParams.set('product',root.querySelector('[data-p3-title]')?.textContent.trim()||'');const current=new URL(location.href);for(const key of['preview_theme_id','pb'])if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));request.href=url.href;request.textContent=request.dataset.requestLabel;}
        else{request.href=request.dataset.defaultHref;request.textContent=request.dataset.defaultLabel;}
      }
    }
    function fitValid(item) {
      return Boolean(selected && item && yearSelect?.value && configSelect?.value && fitRows.some(row => Number(yearSelect.value) >= Number(row.from) && Number(yearSelect.value) <= Number(row.to) && row.configuration === configSelect.value && row.variants.some(id => String(id) === String(item.id))));
    }
    function refresh() {
      const item = variant();
      const fit = mode !== 'custom_fit' || fitValid(item);
      if (mode === 'custom_fit') {
        const state = root.querySelector('[data-shop-fit-state]');
        const key = !selected ? 'exact_choose' : !fitRows.length ? 'exact_unknown' : !yearSelect.value || !configSelect.value ? 'exact_choose_details' : fit ? 'exact_confirmed' : 'exact_mismatch';
        state.textContent = t(key); state.dataset.state = fit ? 'confirmed' : 'pending';
      }
      let key = 'add';
      if (root.dataset.purchasesEnabled !== 'true') key = 'preview';
      else if (root.dataset.missingSize === 'true') key = 'size_missing';
      else if (root.dataset.variantLoading === 'true') key = 'checking_options';
      else if (!item) key = mode === 'sized' ? 'select_size' : 'select_option';
      else if (!item.available) key = 'unavailable';
      else if (!fit) key = 'fit_required';
      root.dataset.purchaseState = key;
      button.disabled = busy || key !== 'add';
      button.textContent = t(key);
      return key === 'add';
    }
    function updateVariant() {
      const item = variant();
      if (item) {
        root.querySelector('[data-shop-price]').textContent = item.priceText;
        const compare = root.querySelector('[data-shop-compare]');
        compare.textContent = item.compareText || ''; compare.hidden = !(item.compare > item.price);
        quantity.min = item.min || 1; quantity.step = item.step || 1;
        if (item.max) quantity.max = item.max; else quantity.removeAttribute('max');
        if (quantity.type === 'hidden' || !quantity.checkValidity()) quantity.value = item.min || 1;
        if (item.image && root.dataset.galleryCatalog === 'true') setImage(item.image);
        if (root.querySelector('[data-p3-native-media]')) root.dispatchEvent(new CustomEvent('cover11:variant-selected', {detail: item}));
        const url = new URL(window.location.href); url.searchParams.set('variant', item.id); history.replaceState({}, '', url);
      }
      if (!item) { root.querySelector('[data-shop-price]').textContent = '—'; const compare = root.querySelector('[data-shop-compare]'); if(compare) compare.hidden = true; }
      errorNode.hidden = true; addedNode.hidden = true; refresh();
    }
    root.addEventListener('cover11:variant-data', event => { variants = Array.isArray(event.detail) ? event.detail : []; updateVariant(); });
    form.querySelectorAll('[name="id"]').forEach(input => input.addEventListener('change', updateVariant));
    window.addEventListener('cover11:vehicle-change', () => { rebuildFit(); refresh(); });
    yearSelect?.addEventListener('change', () => {if(selected&&hasYear(selected,yearSelect.value)&&selected.year!==Number(yearSelect.value))select(selected,Number(yearSelect.value));else refresh();}); configSelect?.addEventListener('change', refresh);
    const guide = root.querySelector('[data-shop-size-dialog]');
    if (guide) { root.querySelector('[data-shop-size-open]').hidden = false; initDialog(guide); root.querySelector('[data-shop-size-open]').addEventListener('click', event => showModal(guide, event.currentTarget)); }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !refresh() || !form.reportValidity()) return;
      busy = true; refresh(); errorNode.hidden = true; addedNode.hidden = true;
      const data = new FormData(form);
      if (mode === 'custom_fit') {
        data.set('properties[Vehicle]', fullName(selected));
        data.set('properties[Year]', yearSelect.value);
        data.set('properties[Configuration]', configSelect.value);
      }
      try {
        const response = await fetch(root.dataset.addUrl, {method: 'POST', body: data, headers: {'Accept': 'application/json'}});
        let body; try { body = await response.json(); } catch (_) { throw new Error(t('network_error')); }
        if (!response.ok) throw new Error(typeof body.description === 'string' ? body.description : t('network_error'));
        addedNode.hidden = false;
        window.dispatchEvent(new Event('c11-cart-refresh'));
        window.dispatchEvent(new Event('c11-cart-open'));
      } catch (error) { errorNode.textContent = error.message || t('network_error'); errorNode.hidden = false; }
      finally { busy = false; refresh(); }
    });
    rebuildFit(); refresh();
  }
  function init(root = document) { initDirectory(root); root.querySelectorAll('[data-shop-product]').forEach(initProduct); }
  init();
  document.addEventListener('shopify:section:load', () => init());
})();

